import React from 'react'

export default function CommingSoon() {
  return (
    <div>
      <section style={{ backgroundColor: '#f8f9fa', height: '100vh', display: 'flex', alignItems: 'center' }}>
      <div className="container" style={{ maxWidth: '800px', textAlign: 'center' }}>
        <h1 className="mb-4">Coming Soon</h1>
        <p className="lead mb-5">We're working hard to bring you an amazing new website. Stay tuned for updates!</p>
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}
